// 该文件保留用于向后兼容
// 新代码请使用 @/app/lib/LocaleProvider 中的 Hook

import zhCN from "./cn";
import enUS from "./en";

import type { LocaleType } from "./cn";
import { mergeObject } from "../utils/object";
import { getUrlParam } from "../utils/url";
import { getEnvRegion } from "../utils/env";
export type { LocaleType, PartialLocaleType } from "./cn";

// 重新导出新的国际化 Hook
export {
  useTranslations,
  useLocale,
  useCurrentLocale,
  useChangeLocale,
  LocaleProvider,
  ALL_LANG_OPTIONS,
  AllLangs,
  type Locale,
} from "../lib/LocaleProvider";

const isOversea = getEnvRegion().startsWith("OR");
const DEFAULT_LANG = isOversea ? "en-US" : "zh-CN";

const ALL_LANGS = {
  "zh-CN": zhCN,
  "en-US": enUS,
};

export type Lang = keyof typeof ALL_LANGS;

// 默认导出（保留用于向后兼容，但建议使用 useTranslations Hook）
const fallbackLang = enUS;

const targetLang = ALL_LANGS[getLang()] as LocaleType;
// 将fallbackLang中的属性值进行替换，由targetLang值优先
mergeObject(fallbackLang, targetLang);

export default fallbackLang as LocaleType;

// 已废弃：使用 useCurrentLocale Hook 替代
export function getLang(): Lang {
  try {
    if (typeof window !== "undefined") {
      const urlObj = new URL(window.location.href);
      // 创建 URLSearchParams 对象处理查询参数
      const params = new URLSearchParams(urlObj.search);
      // 如果URL包含多语言，则优先使用
      const urlLang = params.get("lang");
      if (urlLang) {
        const isCn = ["zh", "zh-cn", "cn"].includes(urlLang.toLowerCase());
        if (isCn) {
          return "zh-CN";
        }
        return "en-US";
      }
    }
    return DEFAULT_LANG;
  } catch {
    return DEFAULT_LANG;
  }
}
export function getPageLang() {
  return getUrlParam("lang") || getLang();
}
